
import { CoreoRecord } from '../../types';

import { RecordsState } from './records.reducer';

export const getRecordFilter = (state: RecordsState) => state.recordFilter;
export const getRecordsLoading = (state: RecordsState) => state.recordsLoading;
export const getRecordsMapLoading = (state: RecordsState) => state.recordsMapLoading;
export const getRecordsRecord = (state: RecordsState): CoreoRecord => state.record;
